/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class StoreIcon extends BaseIcon {
    getChildren = () => [
        <path fill={this.getColor()}
              d="M12.73,1h4.54V17.83a1.34,1.34,0,0,1-1.35,1.35H4.08a1.34,1.34,0,0,1-1.35-1.35V1h10M3.64,4.64V18.27H16.36V4.64ZM5,5.91a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,5,5.91Zm5,0a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,10,5.91Zm5,0a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,15,5.91Zm5,0a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,20,5.91Zm0-.36H0L2.73,1H17.27Z"/>
    ]
    getViewBox = () => '0 0 20 20'
}
